import PropTypes from 'prop-types';
import cc from 'classcat';

import styles from './styles.module.scss';

const Stat = ({ value, label, subLabel, theme, customStyles }) => (
  <div className={cc([styles[theme], styles.stat, customStyles.stat])}>
    <div className={cc([styles.value, customStyles.value])}>{value}</div>
    <div className={cc([styles.name, customStyles.name])}>{label}</div>
    {!!subLabel && (
      <div className={cc([styles.subLabel, customStyles.subLabel])}>
        {subLabel}
      </div>
    )}
  </div>
);

Stat.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.bool,
    PropTypes.string,
  ]),
  label: PropTypes.string,
  subLabel: PropTypes.string,
};

export default Stat;
